module.exports = __webpack_public_path__ + "static/the-new-new-thing-c627dee8bd4e7985ffa456a3293f4501.jpg";